<template>
    <section id="bloque404principal">
        <div class="centrado">
            <p class="centrado__texto404">404</p>
            <p class="centrado__textoVaya">¡Vaya!</p>
            <p class="centrado__textoInfo">Parece que te has perdido...</p>
            <a class="centrado__volverHome" href="/">Volver</a>
        </div>
    </section>
</template>